import {
  FacebookLogoIcon,
  TelegramLogoIcon,
  TwitterLogoIcon,
  WhatsappLogoIcon,
} from '~/components/icons/logos'
import { useRootContext } from '~/hooks/useRootContext'

export type ShareProps = {
  articleTitle: string
  articleAbstract: string | undefined
}

export const useShare = ({ articleTitle }: ShareProps) => {
  const { url } = useRootContext()
  const encodedUrl = encodeURIComponent(url.origin + url.pathname)
  const encodedTitle = encodeURIComponent(articleTitle)
  const facebookUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`
  const twitterUrl = `https://twitter.com/share?text=${encodedTitle}&url=${encodedUrl}`
  const whatsappUrl = `https://wa.me?text=${encodedUrl}`
  const telegramUrl = `https://telegram.me/share/url?url=${encodedUrl}&text=${encodedTitle}`

  return {
    url,
    links: [
      {
        link: facebookUrl,
        label: 'Post on Facebook',
        Icon: FacebookLogoIcon,
      },
      {
        link: twitterUrl,
        label: 'Post on Twitter',
        Icon: TwitterLogoIcon,
      },
      {
        link: whatsappUrl,
        label: 'Send in WhatsApp',
        Icon: WhatsappLogoIcon,
      },
      {
        link: telegramUrl,
        label: 'Send in Telegram',
        Icon: TelegramLogoIcon,
      },
    ],
  }
}
